import QuinielazoService from "@/services/QuinielazoService";

export const namespaced = true;

export const state = {
	notifications_bcast: [],
	notifications:null
};

let nextId = 1;

export const mutations = {
	PUSH(state, notification) {
		state.notifications_bcast.push({
			...notification,
			id: nextId++
		});
	},
	DELETE_BCAST(state, notificationToRemove) {
		state.notifications_bcast = state.notifications_bcast.filter(notification => 
			notification.id !== notificationToRemove.id
		);
	},
	SET_NOTIFICATIONS(state, notifications){
		state.notifications = notifications
	},
	MARK_AS_READ(state, notifications){

    	for (var key in state.notifications) {
    		if (notifications.includes(state.notifications[key].id)) {
    			this._vm.$set(state.notifications[key], 'read_at', new Date().toISOString())
    		}
    	}
	},
	ADD_NOTIFICATION(state, notification){
		state.notifications.unshift(notification)
	},
	DELETE_NOTIFICATION(state, notification){
		state.notifications = state.notifications.filter(not => not.id !== notification.id)
	}
};

export const actions = {
	add({ commit }, notification) {
		commit("PUSH", notification);
	},
	remove({ commit }, notificationToRemove) {
		commit("DELETE_BCAST", notificationToRemove);
	},
	fetchNotifications({commit}){
		return QuinielazoService.getNotifications()
		.then(resp => {
			commit('SET_NOTIFICATIONS', resp.data)
		})
	},
	markAsRead({ commit }, notifications){
		QuinielazoService.marcarNotificacionesLeidas(notifications)
		.then(() => {
			commit('MARK_AS_READ', notifications.notifications)
		})

	},
	push({ commit, dispatch, rootState}, notification){
		if (notification.type == "App\\Notifications\\UsuarioSeUneQuiniela") {
			let msg;
			if (rootState.user.user.user.id != notification.usuario.id) {
				msg = "El usuario " + notification.usuario.name + " se ha unido a tu quiniela <strong>" + notification.quiniela.nombre + "</strong>"
			}else{
				msg = "Te has unido a la quiniela <strong>" + notification.quiniela.nombre + "</strong>"
			}
			dispatch('add',{
				timeout: 10000,
				message: msg
			})
		}

		if (notification.type == "App\\Notifications\\QuinielaGanada") {
			dispatch('add',{
				timeout: 10000,
				message: "Haz ganado la quiniela <strong>"+notification.quiniela.nombre+"</strong> con "+notification.premio+" puntos"
			})	
		}

		if (notification.type == "App\\Notifications\\QuinielaEnJuego") {
			dispatch('add',{
				timeout: 6000,
				message: "La quiniela <strong>"+notification.quiniela.nombre+"</strong> esta ahora en juego, mucha suerte"
			})	
		}

		if (notification.type == "App\\Notifications\\QuinielaTerminada") {
			dispatch('add',{
				message: "Ha finalizado la quiniela <strong>"+notification.quiniela.nombre+"</strong>"
			})
		}

		if (notification.type == "App\\Notifications\\NuevoSeguidor") {
			dispatch('add',{
				timeout: 7000,
				message: notification.usuario.name + " comenzo a seguirte"
			})
			//Update seguidores
			dispatch('user/newFollower', null, {root: true})
		}

		if (notification.type == 'App\\Notifications\\Unfollowed') { //un usuario te dejo de seguir
			dispatch('user/removeFollower', null, {root: true})
			return;
		}

		if (notification.type == 'App\\Notifications\\RecibePuntos') {
			dispatch('add',{
				timeout: 7000,
				message: ((notification.usuario != undefined) ? notification.usuario.name:'Quinielazo') + ' te ha enviado <strong>' + notification.puntos + '</strong> puntos'
			})
		}

		if (notification.type == 'App\\Notifications\\RespuestaASolicitud') {
			let desicion = (notification.solicitud.status == 1) ? 'rechazada' : 'aceptada'
			dispatch('add', {
				timeout: 5000,
				message: 'Tu solicitud de la quiniela ' + notification.quiniela.nombre + ' fue ' + desicion
			})
		}

		if (notification.type == 'App\\Notifications\\SolicitudDeUnion') {
			dispatch('add', {
				timeout: 5000,
				message: 'El usuario ' + notification.usuario.name + ' se quiere unir a una quiniela privada tuya'
			})
		}

		if (this.state.notifications == null) {
			dispatch('fetchNotifications')
		}else{
			commit('ADD_NOTIFICATION', notification)
		}
	},
	delete({commit, dispatch}, notification){
		return QuinielazoService.borrarNotificacion(notification)
		.then(() => {
			commit('DELETE_NOTIFICATION', notification)
		})
		.catch(()=>{
			dispatch('add',{
				type: 'error',
				message: "Hubo un error al borrar la notificacion"
			})
		})
	},
	webPush({dispatch}, message){
		return QuinielazoService.webPushMessage(message)
		.then(resp => {
			dispatch('add',{
				type: 'success',
				message: "Se envio la notificacion"
			})
			return resp
		})
	}
};
